module.exports = __webpack_public_path__ + "img/dial-high.15447c89.svg";